<ui-form-field-layout
	[isRequired]="isRequired()"
	[title]="title()"
	[subtitle]="subtitle()"
	[isValid]="isValid()"
	[hint]="hint()"
	[suffix]="suffix()"
>
	<div class="ui-input" slot="input">
		<input
			[ariaLabel]="title()"
			[ngClass]="inputDesignClass()"
			[attr.maxLength]="maxLength()"
			type="text"
			[placeholder]="placeholder()"
			autocomplete="off"
			[ngModel]="rawValue()"
			(ngModelChange)="handleModelChange($event)"
		/>
	</div>

	<div [class.push-top-md]="isValid() && currentValue()" libFlexRow slot="content">
		<div libFlexColumn [libFlexSize]="isMobileView() ? 'fill' : '400px'">
			@if (isValid()) { @if (currentValue(); as currentValue) {

			<lib-video [url]="currentValue"></lib-video>

			} }
		</div>
	</div>
</ui-form-field-layout>
